export default {
	"order.NoRelevantOrderInformationYet": "No relevant order information yet",
	"order.TradingClosed": "Trading closed",
	"order.YouHaveSuccessfullyAppliedPleaseCheckTheOrderStatusLater": "You have successfully applied, please check the order status later",
	"order.TheSystemIsDeserted": "The system is deserted!",
	"order.SignUpAndPayNow": "Sign up and pay now",
	"order.ApplyForADeduction": "Apply for a deduction",
	"order.callOfficial": "call official",
	"order.ThisTimeYouOnlyNeedToPayTheTransferFee": "This time, you only need to pay the transfer fee:",
	"order.growBeans": "grow beans",
	"order.OrderHasBeenTransferred": "Order has been transferred",
	"order.total": "total:",
	"order.openRecord": "open record",
	"order.ChangeAddress": "Change address",
	"order.fillInTheAddress": "fill in the address",
	"order.ViewLogistics": "View Logistics",
	"order.ImmediatePayment": "Immediate payment",
	"order.loadMore": "load more",
	"order.noMore": "no more",
	"order.hint": "hint",
	"order.understood": "understood",
	"order.ToPayForTheOrderPleasePayInTheOrderLogisticsOfTheCallOfficialAccount": "To pay for the order, please pay in the order logistics of the [Call] official account",
	"order.PleaseEnsureThatYourContractAccountBalanceIsSufficientBeforeMakingADeductionApplication": "Please ensure that your contract account balance is sufficient before making a deduction application",
	"order.Cancel": "Cancel"
}